"use strict";
"use es6";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.execute = void 0;
var _ApolloLink = require("apollo-stack-hubspot/@apollo/client/link/core/ApolloLink");
var execute = exports.execute = _ApolloLink.ApolloLink.execute;